var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M0 10c0-4.714 0-7.071 1.464-8.536C2.93 0 5.286 0 10 0h11c4.714 0 7.071 0 8.536 1.464C31 2.93 31 5.286 31 10v11c0 4.714 0 7.071-1.464 8.536C28.07 31 25.713 31 21 31H10c-4.714 0-7.071 0-8.536-1.464C0 28.07 0 25.713 0 21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.74 14.72a.154.154 0 0 1-.04.118l-6.86 6.86a.145.145 0 0 1-.104.043.145.145 0 0 1-.104-.043l-5.33-5.33a.146.146 0 0 1 0-.206l6.86-6.86a.15.15 0 0 1 .112-.042h.006l4.579.434c.237.023.426.21.448.448l.434 4.579zm-2.563-1.988a.938.938 0 1 0-1.876.001.938.938 0 0 0 1.876-.001z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsIcon);
export default __webpack_public_path__ + "static/media/tags_icon.959d865ec93b57d453f77c3890c0a802.svg";
export { ForwardRef as ReactComponent };